import { cn } from "@utils";
import { ComponentPropsWithoutRef, forwardRef } from "react";

export type IconProps = {
  className?: string;
  size: "xs" | "md" | "sm";
  variant:
    | "x"
    | "dots-vertical"
    | "calendar"
    | "pen"
    | "chart-pie"
    | "check"
    | "success"
    | "info"
    | "error"
    | "chevron-right"
    | "chevron-down"
    | "grip-vertical"
    | "sort"
    | "sort-asc"
    | "sort-desc"
    | "restore"
    | "table-columns"
    | "table-row"
    | "search-outline"
    | "plus"
    | "messages"
    | "annotation"
    | "trash";
};

const BaseIcon = forwardRef<
  HTMLElement,
  ComponentPropsWithoutRef<"span"> & IconProps
>((props, forwardedRef) => {
  const { size, variant, className, ...iconProps } = props;
  return (
    <span
      {...iconProps}
      ref={forwardedRef}
      className={cn(
        className,
        "c-icon",
        `c-icon--size-${size}`,
        `c-icon--variant-${variant}`,
      )}
    />
  );
});

BaseIcon.displayName = "Icon";

export const Icon = (props: IconProps) => (
  <span
    className={cn(
      `c-icon`,
      `c-icon--size-${props.size}`,
      `c-icon--variant-${props.variant}`,
      props.className,
    )}
  />
);

Icon.AsChild = BaseIcon;
